import { Box } from "@mui/material";

const StaffDashboardScreen = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        px: "1.2%",
      }}
    >
      <Box
        sx={{
          border: 1,
          borderColor: "divider",
          bgcolor: "white",
          borderRadius: 2,
          my: "1.2%",
          minHeight: "90vh",
          px: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "70vh",
            flexDirection: "column",
          }}
        >
          <h1>StaffDashboardScreen</h1>
          <p>
            Edit <code>src/App.tsx</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default StaffDashboardScreen;
